// extracted by mini-css-extract-plugin
module.exports = {"Title":"nft-processing_Title__sUwA4","Description":"nft-processing_Description__pu_r6","TxTitle":"nft-processing_TxTitle__3iw6i","TxLink":"nft-processing_TxLink__Lmn1K"};